import { render, staticRenderFns } from "./QuranProgramsChart.vue?vue&type=template&id=181f516d&scoped=true&"
import script from "./QuranProgramsChart.vue?vue&type=script&lang=js&"
export * from "./QuranProgramsChart.vue?vue&type=script&lang=js&"
import style0 from "./QuranProgramsChart.vue?vue&type=style&index=0&id=181f516d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f516d",
  null
  
)

export default component.exports